import { django } from "@/api";
import { PromptHistory, PromptTemplate } from "@/types";

export const createPromptTemplate = async (
  data: Omit<PromptTemplate, "id">
): Promise<PromptTemplate> => {
  const response = await django.post("llm/prompt_template/", data);
  return response.data;
};

export const updatePromptTemplate = async (
  id: string,
  data: Partial<PromptTemplate>
): Promise<PromptTemplate> => {
  const response = await django.patch(`llm/prompt_template/${id}/`, data);
  return response.data;
};

export const getPromptTemplates = async ({
  signal,
  queryKey,
}: {
  signal: AbortSignal;
  queryKey: string[];
}): Promise<PromptTemplate[]> => {
  const project = queryKey[1];
  const response = await django.get("llm/prompt_template/", {
    // params: { project },
    signal,
  });
  return response.data.filter((t) => t.name && t.project && t.user).reverse();
};
